import { render } from "./App.vue?vue&type=template&id=e07e35a0&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e07e35a0&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e07e35a0"]])

export default __exports__